import {barChartOptions} from '../bar-chart/bar-chart-helper';

import {ChartJsMultiSourceOptionsType} from './multi-source-chart-type';

export const multiSourceChartOptions: ChartJsMultiSourceOptionsType = {
    ...barChartOptions,
};
